import { useState, useEffect, useCallback } from 'react';
import { ShoppingBag, X } from 'lucide-react';

const PROOFS = [
  { name: "Sarah M.", location: "Los Angeles, CA", product: "Premium Bee Pollen", time: "2 minutes ago" },
  { name: "Michael R.", location: "Scottsdale, AZ", product: "Pure Royal Jelly", time: "5 minutes ago" },
  { name: "Jennifer L.", location: "San Diego, CA", product: "Raw Honeycomb", time: "8 minutes ago" },
  { name: "David K.", location: "Phoenix, AZ", product: "Propolis Tincture", time: "12 minutes ago" },
  { name: "Amanda T.", location: "San Francisco, CA", product: "Wildflower Honey", time: "15 minutes ago" },
  { name: "Robert W.", location: "Tucson, AZ", product: "Premium Bee Pollen", time: "18 minutes ago" },
  { name: "Lisa H.", location: "Sacramento, CA", product: "Pure Royal Jelly", time: "22 minutes ago" },
  { name: "James P.", location: "Sedona, AZ", product: "Raw Honeycomb", time: "25 minutes ago" },
  { name: "Emily C.", location: "Las Vegas, NV", product: "Propolis Tincture", time: "31 minutes ago" },
  { name: "Chris B.", location: "Portland, OR", product: "Wildflower Honey", time: "38 minutes ago" },
  { name: "Nicole D.", location: "Denver, CO", product: "Premium Bee Pollen", time: "42 minutes ago" },
  { name: "Kevin S.", location: "Seattle, WA", product: "Pure Royal Jelly", time: "48 minutes ago" },
];

const SocialProof = () => {
  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const [isFirst, setIsFirst] = useState(true);

  const show = useCallback(() => {
    if (dismissed) return;
    setIndex(prev => prev % PROOFS.length);
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
      setIndex(prev => (prev + 1) % PROOFS.length);
    }, 5000);
  }, [dismissed]);

  useEffect(() => {
    // First popup after 79 seconds, then every 120 seconds
    const firstTimer = setTimeout(() => {
      show();
      setIsFirst(false);
    }, 79000);

    return () => clearTimeout(firstTimer);
  }, [show]);

  useEffect(() => {
    if (isFirst || dismissed) return;
    const interval = setInterval(show, 120000);
    return () => clearInterval(interval);
  }, [isFirst, dismissed, show]);

  if (!visible || dismissed) return null;

  const proof = PROOFS[index];

  return (
    <div
      className="fixed bottom-6 left-6 z-50 animate-fade-up"
      data-testid="social-proof-popup"
    >
      <div className="bg-bb-rich border border-bb-border shadow-2xl shadow-black/50 p-4 pr-10 max-w-xs relative">
        <button
          onClick={() => { setVisible(false); setDismissed(true); }}
          className="absolute top-3 right-3 c-muted hover:c-cream transition-colors"
          data-testid="social-proof-close"
        >
          <X className="w-3 h-3" />
        </button>
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 bg-bb-gold/10 border border-bb-gold/30 flex items-center justify-center flex-shrink-0 mt-0.5">
            <ShoppingBag className="w-4 h-4 c-gold" />
          </div>
          <div>
            <p className="t-body text-sm c-cream leading-snug">
              <span className="font-medium">{proof.name}</span>
              <span className="c-muted"> in </span>
              <span className="c-gold">{proof.location}</span>
            </p>
            <p className="t-body text-xs c-muted mt-1">
              Just purchased <span className="c-cream">{proof.product}</span>
            </p>
            <p className="t-label text-[9px] c-muted mt-2">{proof.time}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialProof;
